import { render, staticRenderFns } from "./VdrSplit.vue?vue&type=template&id=a586c2c0&scoped=true"
import script from "./VdrSplit.vue?vue&type=script&lang=js"
export * from "./VdrSplit.vue?vue&type=script&lang=js"
import style0 from "./VdrSplit.vue?vue&type=style&index=0&id=a586c2c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a586c2c0",
  null
  
)

export default component.exports